// extracted by mini-css-extract-plugin
module.exports = {"center":"Loader_center__wMcAh","page_center":"Loader_page_center__28xok","lds-roller":"Loader_lds-roller__3zQ00"};